require('../builder/register-builder');
import { useEffect } from 'react';
import { polyfill } from 'smoothscroll-polyfill';
import type { AppProps } from 'next/app';
import { useCookieConsent } from '@zapier/cookies';
import { GlobalStylesProvider } from '@zapier/design-system';
import { builder } from '@builder.io/react';

import { GlobalStyles } from '../components/GlobalStyles';
import { WistiaVideoProvider } from '../components/WistiaVideo/WistiaVideo.context';
import {
  TrackingProvider,
  initializeDatadogRum,
  nextJsReportWebVitals,
} from '../observability';
import {
  startSessionReplay,
  stopSessionReplay,
} from '../observability/datadogRum';

builder.init(process.env.NEXT_PUBLIC_BUILDER_PUBLIC_API_KEY!);
builder.apiVersion = 'v1';

initializeDatadogRum();

// Measure and report web vitals that Next.js tracks to Datadog.
// See: https://nextjs.org/docs/advanced-features/measuring-performance
export const reportWebVitals = nextJsReportWebVitals;

function App({ Component, pageProps }: AppProps) {
  useEffect(() => {
    polyfill();
  }, []);

  const cookieConsent = useCookieConsent();

  useEffect(() => {
    if (cookieConsent.byName.analytics) {
      startSessionReplay();
    } else {
      stopSessionReplay();
    }
  }, [cookieConsent.byName.analytics]);

  return (
    <GlobalStylesProvider isPlatform={true} isRebrand={true}>
      <WistiaVideoProvider>
        <TrackingProvider>
          <GlobalStyles />
          <Component {...pageProps} />
        </TrackingProvider>
      </WistiaVideoProvider>
    </GlobalStylesProvider>
  );
}

export default App;
